import CareerParamsComponent from "./careerParamsComponent.js"
class CareerPagingComponent {

    private pageKey: string = "Page";

    private previousPageButton?: HTMLButtonElement;
    private nextPageButton?: HTMLButtonElement;

    private pagerContainer!: HTMLElement;
    private pagerButtons!: NodeListOf<HTMLButtonElement>;

    public onDomLoaded() {
        this.pagerContainer = document.getElementById("pager-container") as HTMLElement;

        this.pagerButtons = this.pagerContainer.querySelectorAll(".set-paging-item");

        this.pagerButtons.forEach(e => e.addEventListener("click", (event) => {
            event.preventDefault();

            this.setPage(Number(e.getAttribute("data-page")))
        }))

        this.previousPageButton = document.getElementById("previous-page-button") as HTMLButtonElement;

        this.previousPageButton?.addEventListener("click", (event) => {
            event.preventDefault();

            this.previousPage();
        }, { once: true })

        this.nextPageButton = document.getElementById("next-page-button") as HTMLButtonElement;

        this.nextPageButton?.addEventListener("click", (event) => {
            event.preventDefault();

            this.nextPage();
        }, { once: true })
    }

    public setPage(page: number) {
        CareerParamsComponent.searchParams.set(this.pageKey, page.toString());

        CareerParamsComponent.reload();
    }

    public nextPage() {
        const pageNumber = Number(CareerParamsComponent.searchParams.get(this.pageKey) ?? 1);

        console.log(CareerParamsComponent.searchParams);

        CareerParamsComponent.searchParams.set(this.pageKey, (pageNumber + 1).toString());

        CareerParamsComponent.reload();
    }

    public previousPage() {
        let pageNumber = Number(CareerParamsComponent.searchParams.get(this.pageKey));

        CareerParamsComponent.searchParams.set(this.pageKey, (pageNumber - 1).toString());

        CareerParamsComponent.reload();
    }
}

const component = new CareerPagingComponent();

export default component;

window.addEventListener("DOMContentLoaded", () => component.onDomLoaded(), { once: true });